import { arrow } from "../util/svgs";

export default {
  init() {
    // JavaScript to be fired on all pages
    preloadPolyfill();

    let edNavLink = $('.ed-inner-nav').find('.menu-item');
    // let edNavAllSubMenus = edNavLink.find('.sub-menu');
    let edNavOurWorkLink = $('.our-work-nav-link');
    let edNavSupportUsLink = $('.support-us-nav-link');
    let edNav = $('.ed-nav');
    let edNavOurWorkNav = $('.ed-our-work-nav');
    let edNavSupportUsNav = $('.ed-support-us-nav');
    let edFooterMenuExpand = $('.footer-menu-expand, .footer-menu-extend-img');
    let selectElements = $('select');
    let edNavStaffPortalParentLink = $('#menu-staff-portal-menu');
    let edNavStaffPortalLink = edNavStaffPortalParentLink.find('.menu-item-has-children');
    let edNavStaffPortalMenu = edNavStaffPortalLink.find('.sub-menu');
    let edFormHourField = $('.gfield_time_hour');
    let quickDonateFormOptions = $('.ed-quick-donate-options').find('li');
    let quickDonateFormSubmit = $('.ed-quick-donate-section').find('.ed-cta-button');
    let tabsOfInformationTabs = $('.tabs-of-information__tabs').find('.nav-item');
    let edNavMenuLink = $('.ed-menu-icon');
    let edNavCloseMenuLink = $('.ed-menu-close-icon');
    // let edNavMobileLinkScroller = $('.ed-mobile-nav-view-pages-icon');
    // let edNavWrappingUL = $('#menu-support-us, #menu-our-work');
    let videoPlayIcon = $('.video-play-icon');
    let fileDownloadButton = $('.downloads-button');
    let fileDownloadEmailInput = $('#downloads-email-entry');
    let aPDonateButton = $('.ap-donate-button');
    let teamProfile = $('.meet-the-team__single');
    // let outOnCallWrapper = $('.out-on-call-wrapper');
    let searchInputWrapper = $('.search-input-wrapper');
    let searchToggle = $('.search-toggle');
    let searchCloseIcon = searchInputWrapper.find('svg');
    let patientStoriesSlider = $('.patient-stories-wrapper, .patient-stories-split-wrapper');
    let sliderDots = $('.slider-dots');
    let gnaaDonationForm = $('.gnaas-donation-form');

    // Cookie Banner JS
    var banner = $('#cookie-banner');
    var prefUpdate = $('#cookie-pref-update');

    function gtag(){window.dataLayer.push(arguments);}        
    
    $(document).ready(function() {
        var form = $('#cookie-form');
    
        // check if consent is already saved in local storage
        // if not show banner, otherwise we show the preference update message 
        if(!localStorage.getItem('consentMode')) {
            banner.show();
        } else {
            prefUpdate.show();
        }

        form.find('button[type="submit"]').on('click', function() {
            form.find('button[type="submit"]').removeAttr('clicked');
            $(this).attr('clicked', 'true');
        });

        form.on('submit', function(e) {
            e.preventDefault(); 
            var action = $(this).find('button[clicked=true]').val();
            var consentMode = {};
            if(action === 'acceptAll') {
                if(document.querySelector('input[name="marketingConsent"]')) {
                    consentMode.ad_storage = 'granted';
                    document.querySelector('input[name="marketingConsent"]').checked = true;
                }
                if(document.querySelector('input[name="analyticsConsent"]')) {
                    consentMode.analytics_storage = 'granted';
                    document.querySelector('input[name="analyticsConsent"]').checked = true;
                }
                if(document.querySelector('input[name="functionalityConsent"]')) {
                    consentMode.functionality_storage = 'granted';
                    document.querySelector('input[name="analyticsConsent"]').checked = true;
                }
            } else {

                if(document.querySelector('input[name="marketingConsent"]')) {
                    if(form.find('input[name="marketingConsent"]').is(':checked')) {
                        consentMode.ad_storage = 'granted';
                        document.querySelector('input[name="marketingConsent"]').checked = true;
                    } else {
                        consentMode.ad_storage = 'denied';
                        document.querySelector('input[name="marketingConsent"]').checked = false;
                    }
                }
                if(document.querySelector('input[name="analyticsConsent"]')) {
                    if(form.find('input[name="analyticsConsent"]').is(':checked')) {
                        consentMode.analytics_storage = 'granted';
                        document.querySelector('input[name="analyticsConsent"]').checked = true;

                    } else {
                        consentMode.analytics_storage = 'denied';
                        document.querySelector('input[name="analyticsConsent"]').checked = false;
                    }
                }
                if(document.querySelector('input[name="functionalityConsent"]')) {
                    if(form.find('input[name="functionalityConsent"]').is(':checked')) {
                        consentMode.functionality_storage = 'granted';
                        document.querySelector('input[name="functionalityConsent"]').checked = true;
                    } else {
                        consentMode.functionality_storage = 'denied';
                        document.querySelector('input[name="functionalityConsent"]').checked = false;

                    }
                }
            }

            // Sent updated consent choices to GTM
            gtag('consent', 'update', consentMode);
            
            // Save consent to cookie
            localStorage.setItem('consentValidTo', JSON.stringify(new Date().getTime() + 60*24*60*60*1000));
            localStorage.setItem('consentMode', JSON.stringify(consentMode));
    
            window.dataLayer.push({'event': 'consentReceived'});

            banner.hide();
            prefUpdate.show();
            
        });

        $(window).on('load', function() {

            if(localStorage.getItem('consentValidTo')) {
                var consentValidTo = JSON.parse(localStorage.getItem('consentValidTo'));
                if(consentValidTo < new Date().getTime()) {
                    localStorage.removeItem('consentMode');
                    localStorage.removeItem('consentValidTo');
                }
            }

            // check appropriate boxes on page load depending on consent in local storage
            var savedConsent = localStorage.getItem('consentMode');
            if(savedConsent) {
                try {
                    var parsedConsent = JSON.parse(savedConsent);
                    if(parsedConsent.ad_storage === 'granted') {
                        form.find('input[name="marketingConsent"]').prop('checked', true);
                    }
                    if(parsedConsent.analytics_storage === 'granted') {
                        form.find('input[name="analyticsConsent"]').prop('checked', true);
                    }
                    if(parsedConsent.functionality_storage === 'granted') {
                        form.find('input[name="functionalConsent"]').prop('checked', true);
                    }
                } catch (e) {
                    form.find('input[name="marketingConsent"]').prop('checked', false);
                    form.find('input[name="analyticsConsent"]').prop('checked', false);
                    form.find('input[name="functionalConsent"]').prop('checked', false);
                }
            }
    
            // on page load, check if we have a consentMode stored within localStorage, if we don't show the banner
            if(!localStorage.getItem('consentMode')) {
                banner.show();
            } else {
                prefUpdate.show();
            }
        })

        prefUpdate.on('click', function(e) {
            e.preventDefault();
            banner.show();
            prefUpdate.hide();
        });
    });

    // end cookie banner JS

    if(isAndroid()) {
      $('body').addClass('android-device');
    }

    $('p:empty').remove();
    $(':checkbox').checkator();
    $(':radio').checkator();

    $(document).ready(function(){
        edFormHourField.find('label').html("24 hour format");
        selectElements.selectric();
        selectElements.removeAttr("disabled");
        selectElements.selectric("refresh");

        let clockDiv = $('#clockdiv');
        if(clockDiv.length) {
            let deadline = new Date(Date.parse($(clockDiv).attr('data-enddate')));
            initializeClock('clockdiv', deadline);
        }

        quickDonateFormOptions.click(function(){
            quickDonateFormOptions.removeClass("active");
            $(this).addClass("active");
            $('#ed-quick-donate-custom-value').val("");
        });

        $('#ed-quick-donate-custom-value').keyup(function(){
            quickDonateFormOptions.removeClass("active");
        });

        quickDonateFormSubmit.click(function(e){
            e.preventDefault();
            EdSubmitQuickDonateForm();
        });

        aPDonateButton.removeClass("animated slideInUp");

        triggerAnimation();
        EdTriggerSlickSliders();

        $('#menu-item-2362').children('a').click(function(e){
            e.preventDefault();
            $(this).find('.sub-menu').toggleClass('staff-portal-open');
            return false;
        });

        $.each($('link'), function(key, value){
            if($(value).attr('rel') === 'preload') {
                $(value).attr('rel', 'stylesheet');
            }
        });

        searchToggle.click(function(e){
          e.preventDefault();
          searchInputWrapper.toggleClass('search-input-wrapper-open');
          searchInputWrapper.parent().addClass('active');
          return false;
        });

        searchCloseIcon.click(function(){
          searchInputWrapper.removeClass('search-input-wrapper-open');
          searchInputWrapper.parent().removeClass('active');
        });

    });

    $(document).on('gform_post_render', function(){
        selectElements.removeAttr("disabled");
        selectElements.selectric("refresh");
    });

    $(document).on('click', '.add_list_item', function(){
        let selectToUpdate = $(this).closest('tr').next('tr').find('.selectric-ed-gravity-form-list-select').find('.ed-gravity-form-list-select');
        let oldSelectricWrapper = selectToUpdate.closest('.selectric-wrapper');
        selectToUpdate.insertAfter(oldSelectricWrapper);
        oldSelectricWrapper.remove();
        selectToUpdate.selectric();
    });

    $(document).on('click', '.add_list_item', function(){
      let selectToUpdate = $(this).closest('tr').next('tr').find('.selectric-ed-gravity-form-list-select-dietary-requirements').find('.ed-gravity-form-list-select-dietary-requirements');
      let oldSelectricWrapper = selectToUpdate.closest('.selectric-wrapper');
      selectToUpdate.insertAfter(oldSelectricWrapper);
      oldSelectricWrapper.remove();
      selectToUpdate.selectric();
    });

    $(document).on('click', '.delete_list_item', function(){
      selectElements.removeAttr("disabled");
      selectElements.selectric("refresh");
    });

    $('.address_zip').change(function(){
        selectElements.selectric("refresh");
    });

    edNavStaffPortalLink.hover(function(){
        edNavStaffPortalMenu.toggleClass('staff-portal-open');
    });

    edNavStaffPortalLink.click(function(){
        edNavStaffPortalMenu.toggleClass('staff-portal-open');
    });

    edFooterMenuExpand.click(function(e) {
      e.preventDefault();
      if($(window).width() < 992) {
        let footerNav = $('.footer-upper').find('.nav');
        let selectedNav = $(this).parent().parent().find('.nav');

        if(selectedNav.is(':visible')){
          footerNav.slideUp();
        } else {
          footerNav.slideUp();
          selectedNav.slideDown();
        }
      }
    });

    tabsOfInformationTabs.click(function(){
        tabsOfInformationTabs.removeClass("active");
        $(this).addClass("active");
    });

    videoPlayIcon.click(function(){
        $('.video-wrapper').show();
    });

    if(is_touch_device()){
        $('body').addClass("ed-touchscreen");
    }

    // Desktop
    if($(window).width() > 991) {
        edNavSupportUsLink.addClass('active');
        edNav.addClass('ed-nav-open');
        edNavSupportUsNav.addClass('ed-nav-open');

        $(edNavMenuLink).on('click', edNavMenuLink, function() {
            edNav.toggleClass('ed-nav-open');
            edNavMenuLink.parent().hide();
            edNavCloseMenuLink.parent().show();
        });
    
        $(edNavCloseMenuLink).on('click', edNavCloseMenuLink, function() {
            edNav.toggleClass('ed-nav-open');
            edNavCloseMenuLink.parent().hide();
            edNavMenuLink.parent().show();
        });

        edNavOurWorkLink.click(function(e) {
            e.preventDefault();
            toggleMenus(edNavOurWorkNav, edNavSupportUsNav, edNavSupportUsLink);
    
            edNavOurWorkLink.toggleClass('active');
        })
    
        edNavSupportUsLink.click(function(e) {
            e.preventDefault();
            toggleMenus(edNavSupportUsNav, edNavOurWorkNav, edNavOurWorkLink);
    
            edNavSupportUsLink.toggleClass('active');
        })

        edNavLink.mouseover(function() {
        
            let navSubMenu = $(this).children('.sub-menu');
            $(this).addClass('active');
            navSubMenu.addClass('active');
    
        })
    
        edNavLink.mouseleave(function() {
            let navSubMenu = $(this).children('.sub-menu');
            $(this).removeClass('active');
            navSubMenu.removeClass('active');
        })
    }

    // Mobile
    if($(window).width() <= 991) {
        $(edNavMenuLink).on('click', edNavMenuLink, function() {
            edNav.addClass('ed-nav-open');
            edNavMenuLink.parent().hide();
            edNavCloseMenuLink.parent().show();
        })

        $(edNavCloseMenuLink).on('click', edNavMenuLink, function() {
            edNav.removeClass('ed-nav-open');

            edNavCloseMenuLink.parent().hide();
            edNavMenuLink.parent().show();
        })

        $(edNavOurWorkLink).on('click', edNavOurWorkLink, function(e) {
            e.preventDefault();
            toggleMenusMobile(edNavOurWorkNav, edNavSupportUsNav, edNavSupportUsLink);

            edNavOurWorkLink.toggleClass('active');
        })

        $(edNavSupportUsLink).on('click', edNavSupportUsLink, function(e) {
            e.preventDefault();

            toggleMenusMobile(edNavSupportUsNav, edNavOurWorkNav, edNavOurWorkLink);
            edNavSupportUsLink.toggleClass('active');
        })       

        $(edNavLink).find('.ed-mobile-nav-view-pages-icon').on('click', edNavLink, function(e) {
            e.preventDefault();

            let parent = $(this).parent();

            let navSubMenu = parent.children('.sub-menu');
            if(parent.hasClass('active')) {
                parent.removeClass('active');
                navSubMenu.removeClass('active');
            }
            else {
                parent.addClass('active');
                navSubMenu.addClass('active');
            }
        })
    }

    $($(window).resize(function() {

        if($(window).width() > 991) {
            edNavCloseMenuLink.parent().hide();
            edNavMenuLink.parent().hide();

            if(!edNav.hasClass('ed-nav-open')) {
            edNavSupportUsLink.removeClass('active');
            edNavOurWorkLink.removeClass('active');
            edNavSupportUsNav.removeClass('ed-nav-open');
            edNavOurWorkNav.removeClass('ed-nav-open');
            }
        }
    
        if($(window).width() <= 991) {
            if(edNav.hasClass('ed-nav-open')) {
                edNavCloseMenuLink.parent().show();
                edNavMenuLink.parent().hide();
            } else {
                edNavCloseMenuLink.parent().hide();
                edNavMenuLink.parent().show();
            }
        }
    }))

    function toggleMenus(current, other, otherLink) {
        
        if(current.hasClass('ed-nav-open')) {
            current.removeClass('ed-nav-open');
            edNav.removeClass('ed-nav-open');
        } 
        else {
            current.addClass('ed-nav-open');
            edNav.addClass('ed-nav-open');
        }
        
        if(other.hasClass('ed-nav-open')) {
            other.removeClass('active');
            other.removeClass('ed-nav-open'); 
            otherLink.removeClass('active');
        }

    }

    function toggleMenusMobile(current, other, otherLink) {
        
        if(current.hasClass('ed-nav-open')) {
            current.removeClass('ed-nav-open');
            // edNav.removeClass('ed-nav-open');
        } 
        else {
            current.addClass('ed-nav-open');
            // edNav.addClass('ed-nav-open');
        }
        
        if(other.hasClass('ed-nav-open')) {
            other.removeClass('active');
            other.removeClass('ed-nav-open'); 
            otherLink.removeClass('active');
        }

    }

    fileDownloadButton.click(function(e){

        if(!$(this).hasClass('downloads-button-disabled')) {
            let ajaxData = {
                'action': 'record_file_downloads_email',
                'email': fileDownloadEmailInput.val(),
                'pageUrl': window.location.href,
                'filename': $(this).text(),
            };

            $.post('/wp/wp-admin/admin-ajax.php', ajaxData);
        } else {
            e.preventDefault();
        }

    });

    fileDownloadEmailInput.keyup(function(){
        if(validateEmail($(this).val())) {
            fileDownloadButton.removeClass('downloads-button-disabled');
        } else {
            fileDownloadButton.addClass('downloads-button-disabled');
        }
    });

    // outOnCallWrapper.mouseenter(function(){
    //     outOnCallWrapper.addClass('out-on-call-open');
    // });

    // outOnCallWrapper.mouseleave(function(){
    //       outOnCallWrapper.removeClass('out-on-call-open');
    //   });

    $(document).on('click', '.ed-mobile-nav-back-icon', function(e){
        e.preventDefault();
        let containingMenu = $(this).parent().parent().parent();
        let toggledSubMenu = $(this).parent();

        toggledSubMenu.animate({
            left: "210%",
        }, 500);

        containingMenu.animate({
            right: "0",
        }, 500);
    });

    $(document).ajaxComplete(function(event, xhr, settings) {
        $(':checkbox').checkator();
        $(':radio').checkator();
        selectElements.selectric();
        $('#sagepaydirect-card-type').selectric();

        if(settings.url === "/?wc-ajax=get_refreshed_fragments" && $(location).attr('pathname') === "/cart/"){
            location.reload();
        }
    });

    $(window).on('resize', featuredArticleBlocksSlider);

    $('.faq-module__faq-question-and-arrow').click(function(){
      $(this).parent().toggleClass('open');
    });

    $(teamProfile).click(function() {
        let clickedTeam = $(this);
        let teamBioContainer = $(clickedTeam).parent().find('.meet-the-team__visible-bio').find('span');
        let bioContentsContainer = $(clickedTeam).find('.meet-the-team__bio');

        if(bioContentsContainer.length) {
            let bioContents = bioContentsContainer.html();
            let elementOffset = $(clickedTeam).offset();
            let elementWidth = $(clickedTeam).outerWidth();
            let elementCenter = elementOffset.left + (elementWidth / 2);
            let browserCenter = Math.floor(window.innerWidth/2);
            let iconOffset = elementCenter - browserCenter;
            let icon = $(clickedTeam).parent().find('.meet-the-team__bio-icon');
            let appendTargetNumber = parseInt($(clickedTeam).attr('data-count'));

            $(icon).css('left', iconOffset);
            $(teamBioContainer).parent().slideUp(400, function(){
                $(teamBioContainer).html(bioContents);

                if($(window).width() >= 992) {
                    while((appendTargetNumber + 1) % 4) {
                        appendTargetNumber = appendTargetNumber + 1;
                    }

                    let appendTarget = $(clickedTeam).parent().find('*[data-count="' + appendTargetNumber + '"]');

                    while(!$(appendTarget).length) {
                        appendTargetNumber = appendTargetNumber - 1;
                        appendTarget = $(clickedTeam).parent().find('*[data-count="' + appendTargetNumber + '"]');
                    }

                    $(teamBioContainer).parent().parent().insertAfter(appendTarget);
                }

                if($(window).width() < 992 && $(window).width() > 767) {
                    if(!(appendTargetNumber % 2)) {
                        appendTargetNumber = appendTargetNumber + 1;
                    }

                    let appendTarget = $(clickedTeam).parent().find('*[data-count="' + appendTargetNumber + '"]');
                    $(teamBioContainer).parent().parent().insertAfter(appendTarget);
                }

                if($(window).width() <= 767) {
                    let appendTarget = $(clickedTeam).parent().find('*[data-count="' + appendTargetNumber + '"]');
                    $(teamBioContainer).parent().parent().insertAfter(appendTarget);
                }
            });
            $(teamBioContainer).parent().slideDown(400, function(){
                $(icon).css('visibility', 'visible');
            });
        }
    });

    $(".meet-the-team__members").on("click", function(){
        let slider = $(this);
        let slideClicked = $(this).find(".slick-active");
        $(slider).find('.meet-the-team__bio').slideUp();
        $(slideClicked).find('.meet-the-team__bio').slideDown();
    });

    // If element is scrolled into view, fade it in
    $(window).scroll(function() {
        triggerAnimation();

        if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 68)) {
            let offsetAmount = (window.innerHeight + window.scrollY) - (document.body.offsetHeight - 68);
            aPDonateButton.css('bottom', offsetAmount + 'px');
        } else {
            aPDonateButton.css('bottom', '0');
        }
    });

    $(window).load(function(){
        $('.hide-staff-portal-menu').css('display', 'inline');
    });

    // Check if element is scrolled into view
    function isScrolledIntoView(elem) {

      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;

      return (elemTop < docViewBottom);
    }

    function triggerAnimation() {
        $('.animated').each(function() {

            let excludedClasses = [
                'ooc-icon',
                'ap-donate-button',
            ];

            if ((isScrolledIntoView(this) === true)) {
                let applyToThis = true;
                let element = $(this);

                $.each(excludedClasses, function(index, value){
                    if($(element).hasClass(value)) {
                        applyToThis = false
                    }
                });

                if(applyToThis) {
                    $(element).addClass('fadeInUp');

                    setTimeout(function(){
                        $(element).removeClass('fadeInUp');
                        $(element).removeClass('animated');
                    }, 1000);
                }

            }
        });
    }

    function is_touch_device() {
          return 'ontouchstart' in window        // works on most browsers
              || navigator.maxTouchPoints;       // works on IE10/11 and Surface
      }

    function featuredArticleBlocksSlider(){
      let featuredArticleBlocks = $('.featured-article-blocks');

      if(featuredArticleBlocks.length) {
          if ($(window).width() < 992) {
              featuredArticleBlocks.slick({
                  slidesToShow: 1,
                  dots: true,
                  arrows: false,
              });
          } else {
              featuredArticleBlocks.slick('unslick');
          }
      }
    }

    function preloadPolyfill() { /* eslint-disable */
      /*! loadCSS. [c]2017 Filament Group, Inc. MIT License */
      /* This file is meant as a standalone workflow for
      - testing support for link[rel=preload]
      - enabling async CSS loading in browsers that do not support rel=preload
      - applying rel preload css once loaded, whether supported or not.
      */
      (function (w) {
        "use strict";
        // rel=preload support test
        if (!w.loadCSS) {
          w.loadCSS = function () {
          };
        }
        // define on the loadCSS obj
        var rp = loadCSS.relpreload = {};
        // rel=preload feature support test
        // runs once and returns a function for compat purposes
        rp.support = (function () {
          var ret;
          try {
            ret = w.document.createElement("link").relList.supports("preload");
          } catch (e) {
            ret = false;
          }
          return function () {
            return ret;
          };
        })();

        // if preload isn't supported, get an asynchronous load by using a non-matching media attribute
        // then change that media back to its intended value on load
        rp.bindMediaToggle = function (link) {
          // remember existing media attr for ultimate state, or default to 'all'
          var finalMedia = link.media || "all";

          function enableStylesheet() {
            // unbind listeners
            if (link.addEventListener) {
              link.removeEventListener("load", enableStylesheet);
            } else if (link.attachEvent) {
              link.detachEvent("onload", enableStylesheet);
            }
            link.setAttribute("onload", null);
            link.media = finalMedia;
          }

          // bind load handlers to enable media
          if (link.addEventListener) {
            link.addEventListener("load", enableStylesheet);
          } else if (link.attachEvent) {
            link.attachEvent("onload", enableStylesheet);
          }

          // Set rel and non-applicable media type to start an async request
          // note: timeout allows this to happen async to let rendering continue in IE
          setTimeout(function () {
            link.rel = "stylesheet";
            link.media = "only x";
          });
          // also enable media after 3 seconds,
          // which will catch very old browsers (android 2.x, old firefox) that don't support onload on link
          setTimeout(enableStylesheet, 3000);
        };

        // loop through link elements in DOM
        rp.poly = function () {
          // double check this to prevent external calls from running
          if (rp.support()) {
            return;
          }
          var links = w.document.getElementsByTagName("link");
          for (var i = 0; i < links.length; i++) {
            var link = links[i];
            // qualify links to those with rel=preload and as=style attrs
            if (link.rel === "preload" && link.getAttribute("as") === "style" && !link.getAttribute("data-loadcss")) {
              // prevent rerunning on link
              link.setAttribute("data-loadcss", true);
              // bind listeners to toggle media back
              rp.bindMediaToggle(link);
            }
          }
        };

        // if unsupported, run the polyfill
        if (!rp.support()) {
          // run once at least
          rp.poly();

          // rerun poly on an interval until onload
          var run = w.setInterval(rp.poly, 500);
          if (w.addEventListener) {
            w.addEventListener("load", function () {
              rp.poly();
              w.clearInterval(run);
            });
          } else if (w.attachEvent) {
            w.attachEvent("onload", function () {
              rp.poly();
              w.clearInterval(run);
            });
          }
        }


        // commonjs
        if (typeof exports !== "undefined") {
          exports.loadCSS = loadCSS;
        } else {
          w.loadCSS = loadCSS;
        }
      }(typeof global !== "undefined" ? global : this));
    }

    function EdTriggerSlickSliders() {
        let productShowcaseSlider = $('.product-showcase__products');
        let donationsCalloutSlider = $('.donations-callout__donations');
        let meetTheTeamSlider = $('.meet-the-team__members');
        let gallerySlider = $('.gallery__slider');
        let getInvolvedSlider = $('.get-involved-links-slider');

        let productSlideCount = $(productShowcaseSlider).find('.product-showcase__product').length;

        if ( $(window).width() > 576 && productShowcaseSlider.length) {
            productShowcaseSlider.slick({
                infinite: true,
                arrows: true,
                prevArrow: '#product_slider_prev',
                nextArrow: '#product_slider_next',
                slidesToShow: (productSlideCount >= 4 ) ? 4 : productSlideCount,
                slidesToScroll: 1,
                centerMode: false,
            });
        }

        if ( $(window).width() < 576 && donationsCalloutSlider.length) {
            donationsCalloutSlider.slick({
                infinite: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                variableWidth: true,
            });
        }

        if ( $(window).width() < 768 && meetTheTeamSlider.length) {
            meetTheTeamSlider.slick({
              infinite: true,
              autoplay: true,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2,
              centerMode: true,
              variableWidth: false,
              variableHeight: false,
              responsive: [
                  {
                      breakpoint: 575,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                      },
                  },
              ],
            });
        }

        if(gallerySlider.length) {
            gallerySlider.slick({
                dots: true,
                dotsClass: 'gallery-slick-dots',
                infinite: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                        },
                    },
                ],
                slidesToScroll: 1,
                variableWidth: true,
            });

            gallerySlider.find('.slick-slide').click(function(e) {
                e.stopPropagation();

                let slideIndex = $(this).attr("data-slick-index");

                gallerySlider.slick("slickGoTo", slideIndex, true);
            });
        }

        if(getInvolvedSlider.length) {
          getInvolvedSlider.slick({
            dots: false,
            autoplay: true,
            infinite: true,
            arrows: false,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
          });
        }

        featuredArticleBlocksSlider();
    }

    function EdSubmitQuickDonateForm() {
        let donateCustomValueField = $('#ed-quick-donate-custom-value');
        let donateAmount = donateCustomValueField.val();
        let donateType = false;
        let donateFrequency = "";
        let donateErrorMessage = $('.donate-error-message');

        donateErrorMessage.hide();

        if(!donateAmount) {
            $.each(quickDonateFormOptions, function(key, value){
                if($(value).hasClass("active")) {
                    donateAmount = $(value).text().substring(1, $(value).text().length);
                    return false;
                }
            });
        }

        if(!donateAmount) {
            donateErrorMessage.text('You must select a donation amount, or enter one manually');
            donateErrorMessage.show();
        } else {
            if(donateAmount >= 2) {
                if($('.quick-donate-donation-type').find('input:checked').hasClass('ed-quick-donate-regular-donation')) {
                    donateType = "Regular+donation";
                    donateFrequency = "Monthly";
                } else if($('.quick-donate-donation-type').find('input:checked').hasClass('ed-quick-donate-one-off-donation')) {
                    donateType = "One-off+donation";
                    donateFrequency = "";
                }

                if(donateType) {
                    let donationUrl = "/support-us/donations/donations/?dt=" + donateType + "&da=£" + donateAmount + "&dca&df=" + donateFrequency;

                    if(donateAmount !== "5" && donateAmount !== "10" && donateAmount !== "20") {
                        donationUrl = "/support-us/donations/donations/?dt=" + donateType + "&da=Other&dca=£" + donateAmount + "&df=" + donateFrequency;
                    }

                    window.location.href = donationUrl;
                } else {
                    donateErrorMessage.text('You must select either a Monthly donation or a One-off donation');
                    donateErrorMessage.show();
                }

            } else {
                donateErrorMessage.text('You must enter a donation of at least £2');
                donateErrorMessage.show();
            }
        }

    }

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function getTimeRemaining(endtime) {
          var t = Date.parse(endtime) - Date.parse(new Date());
          var seconds = Math.floor((t / 1000) % 60);
          var minutes = Math.floor((t / 1000 / 60) % 60);
          var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
          var days = Math.floor(t / (1000 * 60 * 60 * 24));
          return {
              'total': t,
              'days': days,
              'hours': hours,
              'minutes': minutes,
              'seconds': seconds,
          };
      }

    function initializeClock(id, endtime) {
          var clock = document.getElementById(id);
          var daysSpan = clock.querySelector('.days');
          var hoursSpan = clock.querySelector('.hours');
          var minutesSpan = clock.querySelector('.minutes');
          var secondsSpan = clock.querySelector('.seconds');

          function updateClock() {
              var t = getTimeRemaining(endtime);

              daysSpan.innerHTML = t.days;
              hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
              minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
              secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

              if (t.total <= 0) {
                  clearInterval(timeinterval);
                  $('.countdown-module__summary').hide();
                  $('.countdown-module__after-timer').show();
              }
          }

          updateClock();
          var timeinterval = setInterval(updateClock, 1000);
      }

    function isAndroid() {
      return navigator.userAgent.match(/Android/i);
    }


    patientStoriesSlider.slick({
        dots: true,
        autoplay: true,
        infinite: true,
        appendDots: sliderDots,
        arrows: false,
    });

    /* New Donate - Load Selectric + Checkator, Update styles for all pages but page 1 */
    $(document).on('gform_page_loaded' ,function(event, form_id, current_page){
        let formBody = gnaaDonationForm.find('.gform_body');
    
        $('select').selectric()
        $(':checkbox').checkator();
        $(':radio').checkator();

        if(current_page != 1) {
            formBody.css('background-color', '#FFFFFF');
        }
    });

    
    /* New Donate - Page 1 Validation */
    var page1NextButton;

    // $(page1NextButton).on('click', function(e) {
    //     e.preventDefault();

    //     let currentMonthlyDonation = $('.monthly-donation-check input[value="monthly_donation"]').is(':checked');

    //     if(currentMonthlyDonation) {
    //         if(!($('.donation-radio .gfield-choice-input').is(':checked')) && $('.donation-other-amount .ginput_amount').val() < 5.00) {
    //             $('.gform_fields').after("<div class='donation-amount-error'><span class='gform-icon gform-icon--circle-error'></span>Please enter a valid donation amount</div>");        
    //         }
    //     }

        

    // })

    $(document).on('change', '.donation-radio .gfield-choice-input', function() {
        
        let currentMonthlyDonation = $('.monthly-donation-check input[value="monthly_donation"]').is(':checked');
        let currentOneOffDonation = $('.monthly-donation-check input[value="one_off_donation"]').is(':checked');

        // if a radio button is checked, clear the custom amount field
        if($('.donation-radio .gfield-choice-input').is(':checked')) {
            $('.donation-other-amount .ginput_amount').val('');
        }

        // if(currentMonthlyDonation || currentOneOffDonation) {
        //     $('.gform_fields').next('.donation-amount-error').remove();
        //     page1NextButton.prop('disabled', false);
        // }
    });

    $(document).on('input', '.donation-other-amount .ginput_amount', function() {
        let currentCustomAmount = $('.donation-other-amount .ginput_amount').val();
        let currentMonthlyDonation = $('.monthly-donation-check input[value="monthly_donation"]').is(':checked');
        let currentOneOffDonation = $('.monthly-donation-check input[value="one_off_donation"]').is(':checked');

        if($('.donation-other-amount .ginput_amount').val() !== '') {
            $('.donation-radio .gfield-choice-input').prop('checked', false);
        }

        if(currentMonthlyDonation) {
            if(currentCustomAmount >= 5.00) {
                $('.gform_fields').next('.donation-amount-error').remove();
                page1NextButton.prop('disabled', false);
            } else {
                page1NextButton.prop('disabled', true);
                $('.gform_fields').next('.donation-amount-error').remove();
                if($('.donation-amount-error').length === 0) {
                    $('.gform_fields').after("<div class='donation-amount-error'><span class='gform-icon gform-icon--circle-error'></span>Minimum monthly donation amount is £5.00</div>");
                }
            }
        }

        if(currentOneOffDonation) {
            if(currentCustomAmount > 0.00) {
                $('.gform_fields').next('.donation-amount-error').remove();
                page1NextButton.prop('disabled', false);
            } else {
                page1NextButton.prop('disabled', true);
                $('.gform_fields').next('.donation-amount-error').remove();
                if($('.donation-amount-error').length === 0) {
                    $('.gform_fields').after("<div class='donation-amount-error'><span class='gform-icon gform-icon--circle-error'></span>Please enter a valid donation amount</div>");
                }
            }
        }
    });

    /* New Donate - Direct Debit Preferred Date Calculation */
    $(document).on('change', '.donation-preferred-date .gfield-choice-input', function() {
        
        let formFieldDateDay = $('.donation-first-payment .gfield_date_day').find('input');
        let formFieldDateMonth = $('.donation-first-payment .gfield_date_month').find('input');
        let formFieldDateYear = $('.donation-first-payment .gfield_date_year').find('input');

        let preferredDateChoice = null;
        if($('.donation-preferred-date .gfield-choice-input').is(':checked')) {
            preferredDateChoice = $('.donation-preferred-date .gfield-choice-input:checked').val();
        }

        let now = new Date();
        let minimumFirstDate = new Date(now);
        minimumFirstDate.setDate(minimumFirstDate.getDate() + 14);

        let dateOfFirstPayment = new Date(minimumFirstDate.getFullYear(), minimumFirstDate.getMonth() + 1, 1);
        if(preferredDateChoice === '15th of month') {
            let month = minimumFirstDate.getMonth();
            // accounting for different month lengths?
            // e.g 15/16 for 31 days, 15/15 for 30 days, 15/14 for 29 days, 15/13 for 28 days
            if(minimumFirstDate.getDate() >= 13) {
                month = month + 1;
            }
            dateOfFirstPayment = new Date(minimumFirstDate.getFullYear(), month, 15);
        }

        formFieldDateDay.val(dateOfFirstPayment.getDate());
        formFieldDateMonth.val(dateOfFirstPayment.getMonth()+1);
        formFieldDateYear.val(dateOfFirstPayment.getFullYear());

        let firstPaymentDateDiv = $('.donation-first-payment-date');
        firstPaymentDateDiv.remove();

        // add div to show the date of the first payment after the .donation-preferred-date .gfield_radio
        if($('.gnaas-donation-form--page').length > 0) {
            $('.donation-preferred-date .gfield_radio').after('<div class="donation-first-payment-date">First payment : ' + dateOfFirstPayment.getDate() + '/' + (dateOfFirstPayment.getMonth() + 1) + '/' + dateOfFirstPayment.getFullYear() + '</div>');
        } else if($('.gnaas-donation-form--block').length > 0) {
            $('.donation-preferred-date .gfield_label').after('<div class="donation-first-payment-date">First payment : ' + dateOfFirstPayment.getDate() + '/' + (dateOfFirstPayment.getMonth() + 1) + '/' + dateOfFirstPayment.getFullYear() + '</div>');
        }
    });

    /* New Donate - Styling fix for PayPal payment gateway */
    $(document).on('change', '.donation-payment-method .gfield-choice-input', function() {
        if($('.donation-payment-method .gfield-choice-input:checked').val() == 'paypal') {
            $('.gform_page_footer').addClass('gform_page_footer--no-arrow');
        } else {
            $('.gform_page_footer').removeClass('gform_page_footer--no-arrow');
        }
    });

    /* New Donate - Total amount to be set to the donation amount */
    $(document).on('change', '.donation-total-amount .ginput_total', function() {
        let currentTotalAmount = $('.donation-total-amount .ginput_total').val();
        // set .donation-amount-text to the total amount
        $('.donation-amount-text input').val(currentTotalAmount);
    });

    /* New Donate - Form header arrow nevigation */
    $(document).on('gform_post_render', function() {
        
        // reload the PCA Predict script after the form is rendered
        if (typeof pca !== 'undefined' && typeof pca.load === 'function') {
            pca.load();
        }

        // add prev and next divs to gf_page_steps
        let pageSteps = $('.gf_page_steps');
        
        let pageStepsPrev = $(`<div class="gf_step_prev-button">${arrow}</div>`);
        if($('.gform_page_footer .gform_previous_button').length > 0) {
            pageSteps.prepend(pageStepsPrev);
        }

        let pageStepsNext = $(`<div class="gf_step_next-button">${arrow}</div>`);
        if($('.gform_page_footer .gform_next_button').length) {
            pageSteps.append(pageStepsNext);
        }

    });

    $(document).on('click', '.gf_step_prev-button', function() {
        // get the .gform_page that is currently visible
        let currentVisiblePage = $('.gform_page').filter(function(){
            return $(this).css('display') === 'block';
        });

        // get the previous button that is in the currentVisiblePage gform_page_footer
        let prevButton = currentVisiblePage.find('.gform_page_footer .gform_previous_button');

        //if we have a previous button, click it
        if(prevButton.length) {
            prevButton[0].click();
        }
    });

    $(document).on('click', '.gf_step_next-button', function() {
        // get the .gform_page that is currently visible
        let currentVisiblePage = $('.gform_page').filter(function(){
            return $(this).css('display') === 'block';
        });

        // get the next button that is in the currentVisiblePage gform_page_footer
        let nextButton = currentVisiblePage.find('.gform_page_footer .gform_next_button');

        //if we have a next button, click it
        if(nextButton.length && !nextButton.prop('disabled')) {
            nextButton.click();
        }
    });

    // direct debit bank detail validation
    let directDebitSortCodeField = $('.donation-sort-code input');
    let directDebitAccountNumberField = $('.donation-account-number input');
    let directDebitBankField = $('.donation-bank input');
    let directDebitBranchField = $('.donation-branch input');

    function checkDirectDebitDetails(directDebitSortCodeField, directDebitAccountNumberField, directDebitBankField, directDebitBranchField){
        let enteredSortCode = directDebitSortCodeField.val();
        let enteredAccountNumber = directDebitAccountNumberField.val();

        let errorMessage = "" +
            "<p class='ed-direct-debit-error-message'>" +
            "We were unable to correctly verify your bank details - please contact us <a href='/our-work/contact/'>here</a> for assistance." +
            "</p>";

        if(enteredSortCode !== '' && enteredAccountNumber !== '') {
            if((enteredSortCode.length === 6 || enteredSortCode.length === 8) && (enteredAccountNumber.length === 8)){
                $(directDebitSortCodeField).attr('data-enteredSortCode', enteredSortCode);
                $(directDebitAccountNumberField).attr('data-enteredAccNum', enteredAccountNumber);
                BankAccountValidation_Interactive_Validate_v2_00("AD89-DP54-TY49-AP68", enteredAccountNumber, enteredSortCode);
            } else {
                showErrorMessage($('.donation-direct-debit-confirm'), errorMessage);
            }
        }
    }

    function BankAccountValidation_Interactive_Validate_v2_00(Key, AccountNumber, SortCode) {

        // let enteredBankName = directDebitBankField.find('input').val();
        // let enteredBranchName = directDebitBranchField.find('input').val();
        let submitButton = $('.gform_button[value="Submit"]');

        let errorMessage = "" +
            "<p class='ed-direct-debit-error-message'>" +
            "We were unable to correctly verify your bank details - please contact us <a href='/our-work/contact/'>here</a> for assistance." +
            "</p>";
        // let toAppendErrorMessage = $('#field_5_13');

        $.getJSON("https://api.addressy.com/BankAccountValidation/Interactive/Validate/v2.00/json3.ws?callback=?", {
                Key: Key,
                AccountNumber: AccountNumber,
                SortCode: SortCode
            },
            function (data) {
                // Test for an error
                if (data.Items.length === 1 && typeof(data.Items[0].Error) !== "undefined") {
                    return false;
                }
                else {
                    // Check if there were any items found
                    if (data.Items.length === 0) {
                        showErrorMessage($('.donation-direct-debit-confirm'), errorMessage);
                        return false;
                    }
                    else {
                        if(data.Items[0].IsDirectDebitCapable){
                            $('.donation-sort-code input').val(data.Items[0].CorrectedSortCode);
                            $('.donation-account-number input').val(data.Items[0].CorrectedAccountNumber);
                            $('.donation-bank input').val(data.Items[0].Bank);
                            $('.donation-branch input').val(data.Items[0].Branch);
                        } else {
                            showErrorMessage($('.donation-direct-debit-confirm'), errorMessage);
                            return false;
                        }
                    }
                }
            });

        $(submitButton).click(function(){
            setTimeout(function(){
                $(submitButton).prop("disabled", true);
                $(submitButton).css("opacity", "0.2");
            }, 200);
        });
    }

    function showErrorMessage(toAppendErrorMessage, errorMessage){
        let errorMessageParagraph = $('.ed-direct-debit-error-message');

        if(errorMessageParagraph.length > 0){
            errorMessageParagraph.show();
        } else {
            $(toAppendErrorMessage).append(errorMessage);
        }

        $('.gform_page_footer input[type="button"][value="Submit"]').prop('disabled', true);
    }

    function checkIfErrorMessageCanBeRemoved(directDebitSortCodeField, directDebitAccountNumberField){
        let enteredSortCode = $('.donation-sort-code input').val();
        let enteredAccountNumber = $('.donation-account-number input').val();

        if(enteredSortCode !== '' && enteredAccountNumber !== '') {
            if(enteredSortCode !== $(directDebitSortCodeField).attr('data-enteredSortCode') ||
                enteredAccountNumber !== $(directDebitAccountNumberField).attr('data-enteredAccNum')) {
                $('.ed-direct-debit-error-message').remove();
                $('.gform_page_footer input[type="button"][value="Submit"]').prop('disabled', false);

            }
        }
    }
    if ($('.donation-sort-code input').length && $('.donation-account-number input').length) {
        $(document).on('change', '.donation-sort-code input', function(){
            checkIfErrorMessageCanBeRemoved($('.donation-sort-code input'), $('.donation-account-number input'));
            checkDirectDebitDetails($('.donation-sort-code input'), $('.donation-account-number input'), $('.donation-bank input'), $('.donation-branch input'));
        });

        $(document).on('change', '.donation-account-number input', function(){
            let enteredSortCode = $('.donation-sort-code input').val();
            let enteredAccountNumber = $('.donation-account-number input').val();

            // if the account num and sort code are not correct lengths disable submit button
            if((enteredSortCode.length !== 6 && enteredSortCode.length !== 8) || enteredAccountNumber.length !== 8) {
                $('.gform_page_footer input[type="button"][value="Submit"]').prop('disabled', true);
            } else {
                $('.gform_page_footer input[type="button"][value="Submit"]').prop('disabled', false);
            }

            checkIfErrorMessageCanBeRemoved($('.donation-sort-code input'), $('.donation-account-number input'));
            checkDirectDebitDetails($('.donation-sort-code input'), $('.donation-account-number input'), $('.donation-bank input'), $('.donation-branch input'));
        });
    }
    // setInterval(function(){
    //     // checkIfErrorMessageCanBeRemoved(directDebitSortCodeField, directDebitAccountNumberField);
    //     checkDirectDebitDetails(directDebitSortCodeField, directDebitAccountNumberField, directDebitBankField, directDebitBranchField);
    // }, 1000);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js